import { render, staticRenderFns } from "./EpgConfiguration.vue?vue&type=template&id=2821f418"
import script from "./EpgConfiguration.vue?vue&type=script&lang=js"
export * from "./EpgConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports